import React from "react";
import {
  AreaGraphCardContainer,
  TitleLine,
  ChartContainer,
  TopSection,
  ValueLine,
  ValueText,
  PercentChange,
  DirectionArrow,
  ValueUnit,
  DataSummary,
  ChangeLine,
  DurationText,
} from "./styles";
import Chart from "react-google-charts";
import Loader from "../../../../../common/Loader";
import { GraphColors, GraphSpecificProperties } from "./constants";
import { DurationOptions } from "../DurationSelector/constants";
import { getFormattedRows } from "./utils";
import { isMobile } from "../../../../../../utils/common";
import Error from "../../../../../common/Error";

function AreaGraphCard({
  title,
  data,
  yLabel,
  duration = "1D",
  formatter = (v) => v,
  selectedStock,
  unit = "",
}) {
  let rows =
    data &&
    typeof data !== "string" &&
    getFormattedRows(data, duration, formatter, unit);
  return (
    <AreaGraphCardContainer>
      <TopSection>
        <TitleLine>
          {title} {"> "}
          {selectedStock.name === selectedStock.nasdaq
            ? selectedStock.nasdaq
            : `${selectedStock.name} (${selectedStock.nasdaq})`}
        </TitleLine>
        {!data && (
          <DataSummary isLoading>
            <Loader text={"Loading"} />
          </DataSummary>
        )}

        {data && typeof data === "string" && (
          <DataSummary isLoading>
            <Error text={data} />
          </DataSummary>
        )}
        {data && typeof data !== "string" && (
          <DataSummary>
            <ValueLine>
              <ValueText>{typeof data.currentValue  === "string" ? data.currentValue : formatter(data.currentValue)}</ValueText>
              {unit !== "" ? (
                <ValueUnit>
                  {data.currentValue === 1 ? unit : unit + "s"}
                </ValueUnit>
              ) : (
                ""
              )}
            </ValueLine>
            {data.percentageChange === "NA" ? (
              <ChangeLine color={GraphColors["neutral"]}>
                <PercentChange>No change</PercentChange>
                <DirectionArrow></DirectionArrow>
                <DurationText>
                  {DurationOptions[duration].durationText}
                </DurationText>
              </ChangeLine>
            ) : (
              <ChangeLine
                color={GraphColors[data.positiveTrend ? "good" : "bad"]}
              >
                <PercentChange>
                  {data.percentageChange
                    ? data.percentageChange > 0
                      ? "+"
                      : "-"
                    : ""}
                  {data.percentageChange
                    ? Math.abs(data.percentageChange).toFixed(2) + "% "
                    : ""}
                </PercentChange>
                <DirectionArrow>
                  {data.positiveTrend ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill={GraphColors["good"]}
                    >
                      <path d="M7 11h-6l11-11 11 11h-6v13h-10z" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill={GraphColors["bad"]}
                    >
                      <path d="M17 13h6l-11 11-11-11h6v-13h10z" />
                    </svg>
                  )}
                </DirectionArrow>
                <DurationText>
                  {DurationOptions[duration].durationText}
                </DurationText>
              </ChangeLine>
            )}
          </DataSummary>
        )}
      </TopSection>

      <ChartContainer>
        {!data && <Loader text={"Loading " + title} />}
        {data && typeof data === "string" && (
          <Error text={data + " | " + title} />
        )}
        {data && typeof data !== "string" && (
          <Chart
            width={
              isMobile() ? window.innerWidth - 50 : window.innerWidth - 480
            }
            height={isMobile() ? window.innerHeight / 2 : 450}
            chartType={"AreaChart"}
            loader={<Loader text={"Loading graph | " + title} />}
            columns={[
              { type: "date", label: "Day" },
              { type: "number", label: yLabel },
              { type: "string", role: "tooltip", p: { html: true } },
            ]}
            rows={rows}
            options={{
              hAxis: {
                format: DurationOptions[duration].hAxisFormat,
                gridlines: {
                  color: "#fff",
                },
                ...(GraphSpecificProperties[yLabel] || {}).hAxis,
              },
              vAxis: {
                gridlines: {
                  color: "#fff",
                },
                baseline: 0,
                format: "short",
                ...(GraphSpecificProperties[yLabel] || {}).vAxis,
              },
              chartArea: { width: isMobile() ? "80%" : "90%", height: "80%" },
              intervals: { style: "boxes" },
              curveType: "function",
              colors: [GraphColors[data.positiveTrend ? "good" : "bad"]],
              pointSize: 5,
              tooltip: { isHtml: true },
              legend: {
                position: "none",
              },
              dataOpacity: 0.7,
            }}
          />
        )}
      </ChartContainer>
    </AreaGraphCardContainer>
  );
}
export default AreaGraphCard;
